import { formatRemove } from "@format-string/core";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import { statusContract } from "../../FormCancelContrato/FormCancelContrato";

export interface IHandleGetContracts {
  currentPage?: number | undefined;
  itensPerPage?: number | undefined;
  nameSearch?: string | undefined;
  codProposta?: string | undefined;
  startDateSignature?: string | undefined;
  endDateSignature?: string | undefined;
  startEffectiveDate?: string | undefined;
  endEffectiveDate?: string | undefined;
  startDateEmission?: string | undefined;
  endDateEmission?: string | undefined;
  startVencimentoDate?: string | undefined;
  endVencimentoDate?: string | undefined;
  codeOperadora?: string | undefined;
  modalidade_code?: string | undefined;
  codeCorretor?: string | undefined;
  codeAdministradora?: string | undefined;

  client?: {
    nameOrRazao?: string | undefined;
    cpfCnpj?: string | undefined;
  };

  status?: keyof typeof statusContract | "ALL" | undefined;
  isDeleted?: "TRUE" | "FALSE" | "ALL" | boolean | undefined;
  isVitalicioCorretora?: "TRUE" | "FALSE" | "ALL" | boolean;
  isVitalicioCorretor?: "TRUE" | "FALSE" | "ALL" | boolean;
  isVitalicioSupervisor?: "TRUE" | "FALSE" | "ALL" | boolean;
  isVitalicioGerente?: "TRUE" | "FALSE" | "ALL" | boolean ;
}

export const useHttpTableContratos = () => {
  const { setListContratos } = useContextContrato();
  const { handleGetAlert } = useLayoutMainContext();

  const {
    setQtd_registros,
    setLoadingTable,
    itensPerPage,
    currentPage,
    nameSearch,
  } = useConfigPageContext();

  const handleGet = async (body: IHandleGetContracts) => {
    setLoadingTable(true);
    const isDeletedFilter =
      body.isDeleted === "ALL"
        ? undefined
        : body.isDeleted === "TRUE"
          ? true
          : body.isDeleted === "FALSE"
            ? false
            : body.isDeleted;

    return api
      .post("/getContratos", {
        ...body,
        client: {
          nameOrRazao: body.client?.nameOrRazao,
          cpfCnpj: formatRemove(body.client?.cpfCnpj || ""),
        },
        startEmission: body.startDateEmission,
        endEmission: body.endDateEmission,
        isDeleted: isDeletedFilter,

        page: currentPage,
        limit: itensPerPage,
        filter: nameSearch,
      })
      .then((res) => {
        setListContratos(res.data.data);
        setQtd_registros(res.data.count);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
